module.exports = __webpack_public_path__ + "img/arrow-up-left-circle-fill.0de2caa6.svg";